import { datadogRum } from '@datadog/browser-rum';
import { useAtom } from 'jotai';

import { UserData } from '@/src/application/hooks/useUserDataInterface';
import { atomFreeTrial } from '@/src/atoms/FreeTrial';
import {
  INIT_ONBOARDING_NEW_SS,
  ONBOARDING_NEW_FINISHED,
} from '@/src/modules/OnboardingModule/constants';
import { useOnboardingStatus } from '@/src/modules/OnboardingModule/hooks/useOnboardingStatus';
import { IFreeTrialDemo } from '@/src/presentation/types/interfaces/IFreeTrialDemo';

import Onboarding from './Onboarding';

import InsightsMain from '@/modules/InsightsModule/screens/InsightsMain';

interface HomeProps {
  userData: UserData;
}

const Home = ({ userData }: HomeProps) => {
  const [shouldShowOnboarding, hasError] = useOnboardingStatus();
  const [freeTrialBlockState] = useAtom<IFreeTrialDemo>(atomFreeTrial);

  if (shouldShowOnboarding === true && !hasError) {
    return <Onboarding counter={freeTrialBlockState} />;
  }

  if (shouldShowOnboarding === false || hasError) {
    const wasNewOnboarding = localStorage.getItem(INIT_ONBOARDING_NEW_SS);

    if (shouldShowOnboarding === false && !hasError && wasNewOnboarding) {
      datadogRum.addAction(ONBOARDING_NEW_FINISHED, {
        email: userData.email,
      });
      localStorage.removeItem(INIT_ONBOARDING_NEW_SS);
    }

    return <InsightsMain />;
  }

  return null;
};

export default Home;
